<template>
      <div>
    <Breadcrumbs main="shifts" title="Solo / Duo week limits" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-xl-12 xl-100">
          <b-card header-tag="div" no-body>
            <h5 slot="header">Solo / Duo week limits</h5>
            <div slot="header">

            </div>
            <b-card-body>
                <div class="row">
                    <div
                      class="col-sm-6"

                    >
                      <px-card
                        class="bg-primary static-top-widget-card clickable"
                      >
                        <div slot="with-padding">
                          <div class="media static-top-widget">
                            <div class="align-self-center text-center">
                              <feather
                                type="file-plus"
                                class="middle"
                              ></feather>
                            </div>
                            <div class="media-body">
                              <span class="m-0"
                                >Tydzień
                                <strong> ttt</strong></span
                              >
                              <h6 class="m-0">
                                Do wypłaty:  <br />
                              </h6>
                              <h6 class="mb-0 counter">
                                Data dodania:

                              </h6>
                              <feather type="pocket" class="icon-bg"></feather>
                            </div>
                          </div>
                        </div>
                      </px-card>
                    </div>
                  </div>
            </b-card-body>
          </b-card>
        </div>
      </div>
      <!-- Container-fluid Ends-->
    </div>
  </div>
</template>


<script>
export default {
    data(){
        return {

        }
    },
    computed: {
        returnWeeks(){
            const today = new Date()
            const firstDay = new Date(today.setDate(today.getDate()- today.getDay())).toUTCString()
            const lastDay = new Date(today.setDate(today.getDate()- today.getDay() + 7 )).toUTCString()
            return {fristDay: firstDay, lastDay: lastDay}
        }
    }
}
</script>